<script>
	import { Flag } from 'lucide-svelte';
	import { legendsItinerary } from '$lib/data/legends';

	// Courses played on each day, in itinerary order, with the client's
	// ranking and history notes.
	const coursesByDay = [
		[],
		['Lost Farm (Ranked #5 in Australia)'],
		['Championship Golf Course, Launceston (opening December 2026)'],
		['Ratho Farm (est. 1822)'],
		['7 Mile Beach (ranked #9 in Australia)']
	];
</script>

<section id="itinerary" class="relative bg-[#194139] pb-40 pt-16 lg:pt-24">
	<!-- Diagonal edges, matching the private golf experiences page. -->
	<div
		class="absolute -top-48 left-0 z-10 h-48 w-full"
		style="clip-path: polygon(27% 94%,66% 86%,100% 91%,100% 100%,0 100%,0 88%);"
	>
		<div class="h-full bg-[#194139]"></div>
	</div>
	<div
		class="absolute bottom-0 left-0 z-10 h-48 w-full"
		style="clip-path: polygon(27% 94%,66% 86%,100% 91%,100% 100%,0 100%,0 88%);"
	>
		<div class="h-full bg-white"></div>
	</div>

	<div class="relative mx-auto max-w-7xl px-4">
		<div class="mx-auto max-w-3xl text-center">
			<p class="text-sm font-semibold uppercase tracking-widest text-[#ffd451]">The itinerary</p>
			<h2 class="mt-3 font-heading text-3xl font-semibold tracking-tight text-white sm:text-4xl">
				Four days, four nights, Launceston to Hobart
			</h2>
			<p class="mt-6 leading-7 text-white/80">
				Golf in the mornings, Tasmania in between. Here's how the journey unfolds.
			</p>
		</div>

		<ol class="mx-auto mt-14 max-w-4xl">
			{#each legendsItinerary as day, i}
				<li class="grid grid-cols-[auto_1fr] gap-x-5 pb-12 last:pb-0 sm:gap-x-8">
					<div class="flex flex-col items-center">
						<span
							class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#ffd451] font-heading text-base font-bold text-foreground"
						>
							{i + 1}
						</span>
						{#if i < legendsItinerary.length - 1}
							<span class="mt-3 w-px flex-1 bg-white/20" aria-hidden="true"></span>
						{/if}
					</div>

					<div class="pb-2">
						<!-- Weekday only: the tour runs Thursday to Monday, so numbering these
						     "Day 1–5" would read against the 4 day, 4 night billing. -->
						<p class="text-xs font-semibold uppercase tracking-[0.2em] text-[#ffd451]">
							{day.day}
						</p>
						<h3 class="mt-2 font-heading text-xl font-semibold text-white sm:text-2xl">
							{day.heading}
						</h3>

						{#if coursesByDay[i]?.length}
							<ul class="mt-4 flex flex-wrap gap-2">
								{#each coursesByDay[i] as course}
									<li
										class="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white ring-1 ring-white/15"
									>
										<Flag class="h-3 w-3 text-[#ffd451]" />
										{course}
									</li>
								{/each}
							</ul>
						{/if}

						<div class="mt-2 text-white/80 [&_p]:leading-7">
							<!-- eslint-disable-next-line svelte/no-at-html-tags -- editorial tour content authored in $lib/utils/tourContent -->
							{@html day.content}
						</div>
					</div>
				</li>
			{/each}
		</ol>
	</div>
</section>
